import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\ShowScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/ShowScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
const ShowScheduledTaskController = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShowScheduledTaskController.url(args, options),
    method: 'get',
})

ShowScheduledTaskController.definition = {
    methods: ["get","head"],
    url: '/api/scheduled-task/{scheduled_task}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ScheduledTask\ShowScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/ShowScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
ShowScheduledTaskController.url = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { scheduled_task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: typeof args.scheduled_task === 'object'
        ? args.scheduled_task.id
        : args.scheduled_task,
    }

    return ShowScheduledTaskController.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\ShowScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/ShowScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
ShowScheduledTaskController.get = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShowScheduledTaskController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ScheduledTask\ShowScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/ShowScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
ShowScheduledTaskController.head = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ShowScheduledTaskController.url(args, options),
    method: 'head',
})

export default ShowScheduledTaskController